module.exports = __webpack_public_path__ + "assets/svg/UI/location-blue-0f5804.svg";